import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import JoditEditor from "jodit-react";
import classNames from "classnames";
import { Context } from "../../../utils/context";
import { putData } from "../../../utils/api";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import "../../Tabels/Tabels.css";

const toMessage = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map((v) => toMessage(v, "")).join(", ");
  return value.message || value.original?.sqlMessage || fallback;
};

const EditIngredient = (props) => {
  const id = props.show;
  const { getData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const {
    control,
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
  } = useForm({ defaultValues: { name: "", description: "" } });

  useEffect(() => {
    const loadIngredient = async () => {
      try {
        const response = await getData(`/admin/masters/ingredient/${id}`);
        if (response?.data) {
          reset({
            name: response.data.name || "",
            description: response.data.description || "",
          });
        }
      } catch (error) {
        console.error("Error loading ingredient:", error);
        setShowModal({ code: 500, message: "Unable to load ingredient" });
      }
    };
    loadIngredient();
  }, [getData, id, reset]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name.trim());
      formData.append("description", data.description || "");
      const response = await putData(
        `/admin/masters/ingredient/${id}`,
        formData
      );

      setShowModal({
        code: response?.code || (response?.success ? 200 : 400),
        message: response?.success
          ? response.message
          : toMessage(
              response?.errors || response?.message,
              "Unable to update ingredient"
            ),
      });

      if (response?.success) {
        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.handleClose();
        }, 1000);
      }
    } catch (error) {
      console.error("Error updating ingredient:", error);
      setShowModal({ code: 500, message: "Unable to update ingredient" });
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="ingredient-edit-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="ingredient-edit-title">Edit Ingredient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={12}>
                <Form.Group className="main-form-section mt-3">
                  <Form.Label>Name</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Ingredient name"
                      className={classNames({
                        "is-invalid": errors.name,
                      })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 200,
                          message: "Name must be 200 characters or less",
                        },
                      })}
                    />
                  </InputGroup>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="main-form-section mt-3">
                  <Form.Label>Description</Form.Label>
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <JoditEditor
                        value={value}
                        onBlur={() => {
                          onBlur();
                          trigger("description");
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton
                    name="cancel"
                    handleClose={props.handleClose}
                  />
                  <SaveButton
                    name="save"
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <ModalSave
        message={showModal.message}
        showErrorModal={Boolean(showModal.code)}
      />
    </>
  );
};

export default EditIngredient;
